import './Modal.scss';
import * as React from 'react';
import { connect } from 'react-redux';
import OfflineActivation from 'components/modals/OfflineActivation';
import LicenseSeatDeactivation from 'components/modals/LicenseSeatDeactivation';
import LicenseTradeIn from 'components/modals/LicenseTradeIn';
import CloseModal from 'app/actionCreators/CloseModal';
import { AppState } from 'app/store';
function mapAppStateToProps(appState: AppState): AppState {
  return appState;
}
class Modal extends React.Component<AppState> {
  render() {
    const { mode } = this.props.modal;
    if (mode == null) {
      return null;
    }
    return (
      <div className="Modal">
        <div className="Modal-contentStickyWrapper">
          <div className="Modal-content">{this.modalContent()}</div>
          <div className="Modal-background" onClick={CloseModal}></div>
        </div>
      </div>
    );
  }
  modalContent = () => {
    const { mode } = this.props.modal;
    switch (mode) {
      case 'OfflineActivation':
        return <OfflineActivation {...this.props.modal.offlineActivation} />;
      case 'LicenseSeatDeactivation':
        return (
          <LicenseSeatDeactivation
            {...this.props.modal.licenseSeatDeactivation}
          />
        );
      case 'LicenseTradeIn':
        return (
          <LicenseTradeIn
            {...this.props.modal.licenseTradeIn}
            licenseTradeInValueBySerial={this.props.licenseTradeInValueBySerial}
            licensesBySerial={this.props.licensesBySerial}
            ordersByID={this.props.ordersByID}
          />
        );
      default:
        throw new Error(`unknown modal mode: ${mode || 'undefined'}`);
    }
  };
}
export default connect(mapAppStateToProps)(Modal);
